if (!customElements.get('clear-input')) {
  class ClearInput extends HTMLElement {
    static observedAttributes = ['data-input-value'];

    constructor() {
      super();
    }

    attributeChangedCallback(_name, _oldValue, newValue) {
      this.classList.toggle('hidden', !newValue);
    }

    handleInput() {
      this.setAttribute('data-input-value', this.targetInput.value);
    }

    handleClick(event) {
      // Prevents a bug where pressing 'Enter' clears the input instead of
      // submitting the form.
      if (event.pointerId == -1) return;

      this.targetInput.value = '';
      this.handleInput();
      this.targetInput.focus();

      const eventName = this.getAttribute('data-dispatches');
      if (!eventName) return;

      document.dispatchEvent(new CustomEvent(eventName));
    }

    init() {
      this.targetInput = document.querySelector(
        `input[id="${this.getAttribute('data-input-id')}"]`,
      );

      if (!this.targetInput) return;

      this.targetInput.addEventListener('input', this.handleInput.bind(this));
      this.targetInput.addEventListener('change', this.handleInput.bind(this));

      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      setTimeout(() => {
        this.init();
      }, 300);
    }
  }

  customElements.define('clear-input', ClearInput);
}
